import type { MovementInfoId, MovementWithMusclesInfo } from '@az3fr/core';
import { groupMusclesByRole } from '@az3fr/core';
import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/lib/store';
import { movementAdapter } from '@/entities/movement/model/movement.slice';
import { movementMuscleSliceSelectors } from '@/entities/movement-muscle/model/movement-muscle.selector';
import { muscleSliceSelectors } from '@/entities/muscle/model/muscle.selector';

const baseSelectors = movementAdapter.getSelectors((state: RootState) => state.movements);

const selectMovementWithMuscles = createSelector(
	[
		baseSelectors.selectEntities,
		muscleSliceSelectors.selectEntities,
		movementMuscleSliceSelectors.selectAll,
		(_, movementId: MovementInfoId) => movementId,
	],
	(
		movementsEntities,
		musclesEntities,
		movementMuscles,
		movementId,
	): MovementWithMusclesInfo | undefined => {
		const movement = movementsEntities[movementId];
		if (!movement) {
			return undefined;
		}

		const allMuscles = movementMuscles
			.filter((movementMuscle) => movementMuscle.movementId === movementId)
			.map((movementMuscle) => ({
				role: movementMuscle.role,
				muscle: musclesEntities[movementMuscle.muscleId],
			}));

		return {
			...movement,
			muscles: groupMusclesByRole(allMuscles),
		};
	},
);

const movementSliceSelectors = {
	...baseSelectors,
	selectMovementWithMuscles,
};

export { movementSliceSelectors };
